import { IController } from 'angular';

import { ISchool } from '../../../../../ng2/shared/typings/interfaces/school.interface';
import { SpinnerModal } from './../../../../shared/modals/status-spinner/status-spinner.service';

export class CourseDiffsGapPlansCtrl implements IController {
  static $inject = ['gapPlans', 'courseDiffs', 'currentSchool', 'currentUser', 'SpinnerModal'];

  constructor(
    public gapPlans,
    public courseDiffs,
    public currentSchool: ISchool,
    public currentUser,
    private SpinnerModal: SpinnerModal,
  ) {}

  $onInit() {
    this.SpinnerModal.deactivateSpinner();
  }
}
